import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';

import RseeTimePicker from '../../../components/timePicker';
import Spin from '../../../components/loading';
import ShowForPermission from '../../../components/ShowForPermission';

import * as reservationActions from '../../../redux/reservations/actions';
import * as reserveTimesActions from '../../../redux/reserveTimes/actions';
import ENUMS from '../../../enums';
import { toStandard } from '../../../utils/formatter';
import AlertAndConfirmation from '../../../utils/AlertAndConfirmation';

class CreateReserveHour extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      status: '',
      date: '',
      loaded: false,
      tableNumber: '',
      cafeTableId: '',
      fromTime: '',
      toTime: ''
    };
  }

  componentDidMount() {
    if (this.props.location.editMode) {
      this.props.actions.fetchReservationHourDetails(this.props.location.reservationHourId);
    }

    this.props.actions.fetchAllTableNumbers();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.location.editMode &&
      prevState.loaded == false &&
      Object.entries(this.props.reservationHourDetails).length
    ) {
      let { status, fromTime, toTime, date, tableNumber, cafeTableId } = this.props.reservationHourDetails;

      this.setState({ status, fromTime, toTime, tableNumber, date, cafeTableId, loaded: true });
    }
  }

  handleStatusChange = event => {
    this.setState({ status: event.target.value });
  };

  setFromTime = time => {
    this.setState({ fromTime: time });
  };

  setToTime = time => {
    this.setState({ toTime: time });
  };

  submitForm = () => {
    let { fromTime, toTime, tableNumber, cafeTableId, status } = this.state;

    if (this.props.location.editMode) {
      let updateObject = {
        id: this.props.location.reservationHourId,
        cafeTableId: cafeTableId,
        fromTime,
        toTime,
        status
      };

      this.props.actions.updateReservationHour(updateObject).then(() => {
        let { updateFailed, updateMessage, updateError } = this.props;
        if (updateFailed == false && updateMessage == null && updateError == false) {
          AlertAndConfirmation({
            title: locales('titles.editionsDoneSuccessfully'),
            text: '',
            type: 'success'
          });
          this.props.history.push({
            pathname: `/reservation-day/hours/${this.props.location.reservationDayId}`,
          });
        }
      });
    } else {
      let reservationHourObject = {
        fromTime,
        toTime,
        cafeTableId: tableNumber.value,
        cafeDateId: this.props.location.reservationDayId,
        status
      };

      this.props.actions.insertNewReservationHour(reservationHourObject).then(() => {
        let { failed, message, error } = this.props;
        if (failed == false && message == null && error == false) {
          AlertAndConfirmation({
            title: locales('titles.insertedSuccessfully'),
            text: '',
            type: 'success'
          });
          this.props.history.push({
            pathname: `/reservation-day/hours/${this.props.location.reservationDayId}`,
          });
        }
      });
    }
  };

  render() {
    let {
      loading,
      message,
      failed,
      error,
      updateError,
      updateMessage,
      updateFailed,
      updateLoading,
      detailsError,
      detailsFailed,
      detailsLoading,
      detailsMessage,
      tableNumbersError,
      tableNumbersFailed,
      tableNumbersLoading,
      tableNumbersMessage,
      tableNumbersList
    } = this.props;

    let { status, date, tableNumber, fromTime, toTime } = this.state;
console.log(this.props.location.reservationDayId)
    return (
      <>
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h3 className="text-right text-muted py-4">
            <div className="text-right">{locales('titles.insertOrEditReservationHour')}</div>
          </h3>
          <div>
            <button onClick={() => this.submitForm()} className="btn btn-success w-5 mx-1">
              <i className="fa fa-save" />
              {locales('labels.save')}
            </button>
            <button
              onClick={() => {
                this.props.history.push({
                  pathname: `/reservation-day/hours/${this.props.location.reservationDayId}`,
                });
              }}
              className="btn btn-default w-5 mx-1"
            >
              <i className="fa fa-reply" />
              {locales('labels.cancel')}
            </button>
          </div>
        </div>
        <section className="p-1 col-12">
          <Spin spinning={loading || tableNumbersLoading || detailsLoading || updateLoading}>
            <article>
              <main className="panel panel-default">
                {(error || tableNumbersError || detailsError || updateError) && (
                  <div className="alert alert-danger">{locales('messages.server.error')}</div>
                )}
                {(failed || tableNumbersFailed || detailsFailed || updateFailed) && (
                  <div className="alert alert-danger">
                    {message || tableNumbersMessage || detailsMessage || updateMessage}
                  </div>
                )}
                <Spin spinning={loading}>
                  <div className="panel-heading">
                    <i className="fas fa-list-alt px-1" />
                    {locales('titles.insertOrEditReservationHourFrom')}
                  </div>
                  <div className="panel-body"></div>
                  <div className="col-12">
                    <div className="col-12 d-flex">
                      <div className="col-4 d-flex p-0 justify-content-start align-items-center">
                        <label className="col-4 p-0" htmlFor="date">
                          {locales('tables.date')} :{' '}
                        </label>
                        <div className="col-5">
                          {date && date.length ? date : this.props.location.reservationDayDate}
                        </div>
                      </div>

                      <ShowForPermission permission={ENUMS.PERMISSIONS.values.VIEW_CAFE_TABLES_LIST}>
                        <div className="col-4 d-flex justify-content-start align-items-center">
                          <Select
                            placeholder={tableNumber || locales('tables.tableNumber')}
                            name="tableNumber"
                            className="p-0 col-9"
                            isMulti={false}
                            value={tableNumber}
                            options={tableNumbersList.map(item => ({
                              label: item.num,
                              value: item.id
                            }))}
                            onChange={tableNumber => this.setState({ tableNumber })}
                          />
                        </div>
                      </ShowForPermission>
                    </div>

                    <div className="col-4 d-flex justify-content-start p-0 my-3 align-items-center">
                      {ENUMS.CAFE_RESERVATION_HOURS.list.slice(0, 2).map(item => (
                        <div
                          key={item.value}
                          className="col-6 d-flex justify-content-start align-items-center"
                        >
                          <label className="pl-1">{item.title}</label>
                          <input
                            type="radio"
                            name="status"
                            checked={item.value == status}
                            onChange={() => this.setState({ status: item.value })}
                          />
                        </div>
                      ))}
                    </div>

                    <div className="col-12 d-flex p-0 my-3">
                      <div className="col-6 d-flex align-items-center justify-content-start p-0">
                        <label className="col-2" htmlFor="fromTime">
                          {locales('tables.fromHour')} :
                        </label>
                        <RseeTimePicker
                          className="form-control col-5"
                          type="time"
                          onChange={this.setFromTime}
                          value={toStandard(fromTime)}
                          name="fromTime"
                          id="fromTime"
                          format="HH:mm"
                          disabled={this.props.location.editMode}
                        />
                      </div>

                      <div className="col-6 d-flex align-items-center justify-content-start p-0">
                        <label className="col-2" htmlFor="toTime">
                          {locales('tables.toHour')} :
                        </label>
                        <RseeTimePicker
                          className="form-control col-5"
                          type="time"
                          onChange={this.setToTime}
                          value={toStandard(toTime)}
                          name="toTime"
                          id="toTime"
                          format="HH:mm"
                          disabled={this.props.location.editMode}
                        />
                      </div>
                    </div>
                  </div>
                </Spin>
              </main>
            </article>
          </Spin>
        </section>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.reserveTimesReducer.insertNewReservationHourLoading,
    message: state.reserveTimesReducer.insertNewReservationHourMessage,
    failed: state.reserveTimesReducer.insertNewReservationHourFailed,
    error: state.reserveTimesReducer.insertNewReservationHourError,

    tableNumbersLoading: state.reservationsReducer.tableNumbersLoading,
    tableNumbersMessage: state.reservationsReducer.tableNumbersMessage,
    tableNumbersFailed: state.reservationsReducer.tableNumbersFailed,
    tableNumbersError: state.reservationsReducer.tableNumbersError,
    tableNumbersList: state.reservationsReducer.tableNumbersList,

    updateLoading: state.reserveTimesReducer.updateReservationHourLoading,
    updateMessage: state.reserveTimesReducer.updateReservationHourMessage,
    updateFailed: state.reserveTimesReducer.updateReservationHourFailed,
    updateError: state.reserveTimesReducer.updateReservationHourError,

    detailsLoading: state.reserveTimesReducer.reservationHourDetailsLoading,
    detailsMessage: state.reserveTimesReducer.reservationHourDetailsMessage,
    detailsFailed: state.reserveTimesReducer.reservationHourDetailsFailed,
    detailsError: state.reserveTimesReducer.reservationHourDetailsError,
    reservationHourDetails: state.reserveTimesReducer.reservationHourDetails
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      fetchReservationHourDetails: id => dispatch(reserveTimesActions.fetchReservationHourDetails(id)),
      updateReservationHour: reservationHourObject =>
        dispatch(reserveTimesActions.updateReservationHour(reservationHourObject)),
      fetchAllTableNumbers: () => dispatch(reservationActions.fetchAllTableNumbers()),
      insertNewReservationHour: reservationObject =>
        dispatch(reserveTimesActions.insertNewReservationHour(reservationObject))
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateReserveHour);
